import { useEffect, useState } from 'react'
import { api, type FindingsAttention, type FindingsAttentionScope } from './api.ts'

export function useFindingsAttention(
  scope: FindingsAttentionScope,
  page: number,
): { answered: FindingsAttention | undefined; loading: boolean; error: string | undefined } {
  const [answered, setAnswered] = useState<FindingsAttention | undefined>()
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | undefined>()

  useEffect(() => {
    let current = true
    setLoading(true)
    setError(undefined)
    api
      .findingsAttention(scope, page)
      .then((result) => {
        if (current) setAnswered(result)
      })
      .catch((cause: unknown) => {
        if (current) setError(cause instanceof Error ? cause.message : 'falhou')
      })
      .finally(() => {
        if (current) setLoading(false)
      })
    return () => {
      current = false
    }
  }, [scope, page])

  return { answered, loading, error }
}
